import { useTranslation } from '../../i18n/i18n';
import { ApiDeliveryAddress } from '../../types';
import { Select } from '../Select/Select';
import { renderValue } from './utils';

type Props = {
	selectedAddress: string;
	onSelectAddress: (addressId: string) => void;
	deliveryAddresses: ApiDeliveryAddress[];
};

export const CheckoutSelectDeliveryAddress = ({
	selectedAddress,
	onSelectAddress,
	deliveryAddresses,
}: Props): JSX.Element | null => {
	const t = useTranslation().form;

	if (!deliveryAddresses || deliveryAddresses.length <= 0) return null;

	return (
		<Select
			list={deliveryAddresses}
			value={selectedAddress}
			renderValue={renderValue}
			placeholder={t.pickFromSavedDeliveryAddresses}
			size="large"
			onSelect={(e) => onSelectAddress(e.currentTarget?.id ? String(e.currentTarget.id) : '')}
			idField="id"
			searchValue={(query: string, addresses: ApiDeliveryAddress[]) =>
				addresses.find((s) => s.id !== undefined && String(s.id) === query)
			}
		/>
	);
};
